"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneMissedIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PhoneMissedIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.705 4.91a1 1 0 0 0-1.414-1.414L17.855 4.93 16.42 3.496a1 1 0 1 0-1.414 1.414l1.435 1.435-1.435 1.436a1 1 0 0 0 1.414 1.414l1.435-1.436 1.436 1.436a1 1 0 1 0 1.414-1.414L19.27 6.345l1.435-1.435ZM13.263 16.23c.262.026.491-.033.666-.208.746-.746 1.115-1.115 1.593-.956.324.108.854.227 1.36.34.488.109.953.213 1.19.297.439.159.636.425.636.638v2.549c0 .51-.424.637-.637.637-1.04.07-3.142-.197-5.469-1.384a14.936 14.936 0 0 1-3.77-2.758c-1.155-1.155-1.99-2.288-2.593-3.345C4.63 9.218 4.675 6.943 4.688 6.267l.002-.12c0-.51.424-.638.637-.638h2.549c.199 0 .489.193.637.637.212.637.637 2.04.637 2.55 0 .217 0 .36-.038.492-.073.256-.288.47-.918 1.1-.218.219-.234.546-.123.925.279.947 1.352 2.216 2.035 2.899.831.831 2.21 2.026 3.157 2.12Zm4.894 5.295a2.71 2.71 0 0 0 1.48-.503 2.588 2.588 0 0 0 1.071-2.132v-2.55c0-1.446-1.171-2.235-1.96-2.518-.36-.13-.938-.259-1.355-.351l-.101-.023c-.543-.121-.94-.213-1.138-.28-1.014-.337-1.874-.008-2.447.38a5.362 5.362 0 0 0-.599.482c-.514-.328-1.113-.859-1.588-1.334-.413-.413-.965-1.052-1.308-1.61.158-.17.364-.403.533-.686.415-.691.408-1.36.405-1.648v-.058c0-.566-.19-1.306-.308-1.746a27.132 27.132 0 0 0-.432-1.435c-.302-.908-1.153-2.005-2.534-2.005h-2.55a2.71 2.71 0 0 0-1.566.504 2.588 2.588 0 0 0-1.07 2.133v.035l-.003.088-.002.274c0 .22.006.502.03.834.048.663.168 1.518.45 2.505.568 1.988 1.773 4.439 4.252 6.918 3.972 3.972 8.587 4.853 10.74 4.726Z"
}));
exports.PhoneMissedIcon = PhoneMissedIcon;